<template>
  <vs-row>
    <vs-col vs-w="12">
      <vs-card style="padding:10px;">
        <div slot="header">
          <h2>Analytics Page</h2>
        </div>
      </vs-card>
    </vs-col>
  </vs-row>
</template>
<script>
export default {
  name: 'Analytics',
  data () {
    return {
    }
  }
}
</script>
